import { gql } from '@apollo/client'

export const GET_PARTNERS = gql`
  query GetPartners($input: BusinessPartnersInput, $pagination: PaginationV2) {
    businessPartners(input: $input, pagination: $pagination) {
      total
      items {
        id
        name
        isActive
        city {
          id
          name
        }
        numberOfVehicles
      }
    }
  }
`

export const GET_PARTNER = gql`
  query GetPartner($id: UUID!) {
    businessPartner(id: $id) {
      id
      name
      taxInfo {
        businessName
        personType
        companyName
        rfc
        curp
        taxRegime
        proofOfTaxSituation
        repseID
        repseLink
      }
      isActive
      city {
        id
        name
      }
      stateCode
      operationalStateCodes
      verticals
      type
      documents {
        id
        category
        filename
        url
      }
      kamUser {
        id
        firstName
        lastName
      }
      contacts {
        email
        id
        name
        phone
        secondaryEmail
        secondaryPhone
      }
      bankDetails {
        bankCoverLink
        bankName
        clabe
        paymentEmail
        paymentType
      }
    }
  }
`

export const GET_PARTNERS_SUGGESTIONS = gql`
  query GetPartnersSuggestions($input: PartnerSuggestionsInput!) {
    partnerSuggestions(input: $input) {
      total
      items {
        id
        name
      }
    }
  }
`
